import { useSharedSpaceValidations, type ISpaceValidations } from '@gem/modules/validations';

import { spaceAliasAsyncValidation } from '../fields/fields';

export const useSpaceValidations = (): ISpaceValidations => {
  return useSharedSpaceValidations({
    spaceAliasAsyncValidation,
  });
};
